import React, { FC, PropsWithChildren, ReactElement, ReactNode } from "react"

import { TablerIconsProps } from "@tabler/icons-react"
import { Card, Group, Stack, Text, useMantineTheme } from "@mantine/core"
import { useMediaQuery } from "@mantine/hooks"

type SettingsCardProps = {
    title: ReactNode
    icon: FC<TablerIconsProps>
    action?: ReactElement
    description?: ReactNode
}

const SettingsCard: FC<PropsWithChildren<SettingsCardProps>> = ({
    title,
    icon: Icon,
    action,
    description,
    children,
}) => {
    const theme = useMantineTheme()
    const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.md})`)

    return (
        <Card withBorder>
            <Stack>
                <Group position="apart" align="start" noWrap>
                    <Text color="dimmed" weight="bold" sx={theme => ({ fontFamily: theme.headings.fontFamily })}>
                        <Group spacing="xs" noWrap>
                            <Icon size={20} />
                            {title}
                        </Group>
                    </Text>
                    {action}
                </Group>
                {description && (
                    <Text size="sm" color="dimmed" maw={mobile ? "100%" : "60%"}>
                        {description}
                    </Text>
                )}
                {children}
            </Stack>
        </Card>
    )
}

export default SettingsCard
